import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';

export const subscribeNewsletter = (email: string) => {
  const url = getUrl(ROUTES.NEWSLETTER);
  const body = { isAjax: 1, email };
  return ApiHelper(url, { method: 'POST', body }).then((data: Response) => data.json());
};

export const getSearchAutoSuggest = (term: string) => {
  const url = `${getUrl(ROUTES.SEARCH_AUTO_SUGGEST)}?searchTerm=${encodeURIComponent(term)}`;

  return ApiHelper(url).then((data: Response) => data.json());
};
